import { api } from "./api";
import { IDoctor } from "../../types/doctor";
import { config } from "../../config/environment";

const CLINIC_ID = config.clinic.id;

export const doctorService = {
  getAllDoctors: async () => {
    const response = await api.get<IDoctor[]>(`/clinics/${CLINIC_ID}/doctors`);
    return response.data;
  },

  getDoctorById: async (doctorId: string) => {
    const response = await api.get<IDoctor>(
      `/clinics/${CLINIC_ID}/doctors/${doctorId}`
    );
    return response.data;
  },

  getDoctorBySlug: async (slug: string) => {
    const response = await api.get<IDoctor>(
      `/clinics/${CLINIC_ID}/doctors/${slug}`
    );
    return response.data;
  },
};
